module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/room-bd86b9c0bab75aa8c632388dd6d2650e.webp";